export enum DonationFrequency {
	Monthly = 'monthly',
	OneTime = 'once',
	Yearly = 'yearly',
	Unselected = ''
}
